import { Button, Form, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { CreateEmail } from './create-email'
import { CreatePhishing } from './create-phishing'
import { CreateAccessory } from './create-accessory'
import Scrollbars from 'react-custom-scrollbars'
import styled from 'styled-components'
import { SignTitle } from '@/components'
import { t } from '@/i18n'
const { useForm } = Form
interface Template {
  isModalVisible: boolean
  handleCancel: (data: any) => void
  cont: string
}
export const GetPhishingParamsCreateTemplate = (props: Template) => {
  const { isModalVisible, handleCancel, cont } = props
  const [submit, setSubmit] = useState({ accomplish: false, timestamp: null })
  const [form] = useForm()
  let [selectTab, setSelectTab] = useState<'email' | 'phishing' | 'accessory' | ''>(null)
  const tabClickHanlder = (name: 'email' | 'phishing' | 'accessory' | '') => () => {
    setSubmit({ accomplish: false, timestamp: new Date().getTime() })
    setSelectTab(name)
  }
  const acquire = () => {
    handleCancel(true)
    setSubmit({ accomplish: false, timestamp: new Date().getTime() })
  }
  useEffect(() => {
    if (isModalVisible) {
      switch (cont) {
        case '1':
          tabClickHanlder('email')()
          break
        case '2':
          tabClickHanlder('phishing')()
          break
        case '3':
          tabClickHanlder('accessory')()
          break
        default:
          break
      }
      return
    }
    tabClickHanlder('')()
  }, [isModalVisible])
  return (
    <Create
      title={
        <>
          {cont === '1' && <SignTitle show>{t('添加自定义邮件模板')}</SignTitle>}
          {cont === '2' && <SignTitle show>{t('添加自定义钓鱼页模板')}</SignTitle>}
          {cont === '3' && <SignTitle show>{t('添加自定义附件模板')}</SignTitle>}
        </>
      }
      visible={isModalVisible}
      onOk={() => {
        form.submit()
        // setSubmit({ accomplish: true, timestamp: new Date().getTime() })
      }}
      onCancel={() => {
        tabClickHanlder(null)()
        form.resetFields()
        handleCancel(false)
      }}
      destroyOnClose
      width={800}
      okText="保存"
      centered
    >
      <div style={{ width: '100%', height: '450px' }}>
        <Scrollbars>
          {selectTab === 'email' && <CreateEmail submit={submit} acquire={acquire} form={form} />}
          {selectTab === 'phishing' && (
            <CreatePhishing submit={submit} acquire={acquire} form={form} />
          )}
          {selectTab === 'accessory' && (
            <CreateAccessory submit={submit} acquire={acquire} form={form} />
          )}
        </Scrollbars>
      </div>
    </Create>
  )
}

const Create = styled(Modal)`
  .ant-modal-body {
    padding-top: 0;
    padding-bottom: 10;
  }
  .header-table {
    width: 100%;
    display: flex;
    border-radius: 8px;
    margin-bottom: 18px;
    height: 32px;
    .tab-item {
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: center;
      background-color: #efefef;
      align-items: center;
      margin-right: 4px;
      &:nth-child(1) {
        border-radius: 16px 0px 0px 16px;
      }
      &:nth-last-child(1) {
        border-radius: 0px 16px 16px 0px;
      }
    }
  }
`
